import React from 'react';
import './SearchBar.css';

const SearchBar = () => {
  return (
    <section className="search-section">
      <div className="search-container">
        <input 
          type="text" 
          placeholder="Search for products..." 
          className="search-input"
        />
        <button className="search-btn">Search</button>
      </div>
    </section>
  );
};

export default SearchBar;
